core.constant('deviceMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "TABBAR": {
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
        },
        "DEVICE": {
          "DEVICE_LABEL" : "Nazwa urządzenia",
          "ACTION" : "Akcje",
          "DEVICE_DELETE_CONFIRMATION" : "Czy chcesz usunąć wybrane urządzenie?"
        }
      }
    }
  }
});
